import React from "react";
import Logo from "../images/logo.png";
import { FaFacebookSquare } from "react-icons/fa";
import { BsInstagram } from "react-icons/bs";
import { BsTwitter } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";
import { BiLogoGithub } from "react-icons/bi";
import { SlUserFollowing } from "react-icons/sl";
import { HiOutlineBriefcase } from "react-icons/hi";
import { PiGraduationCap } from "react-icons/pi";
import { LuLayers } from "react-icons/lu";
import { BiMessage } from "react-icons/bi";
import { GiSkills } from "react-icons/gi";
import {BsFillTelephoneOutboundFill} from 'react-icons/bs'
import {RiMailCheckFill} from 'react-icons/ri'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer1">
        <img src={Logo} alt="logo" />
        <p>Experienced Web Developer with 3+ years in modern, responsive web design and development.</p>
      </div>
      <div className="footer2">
        <h4>SECTIONS</h4>
        <a href="#about"> <SlUserFollowing/> About</a>
        <a href="#services"> <HiOutlineBriefcase/> Services</a>
        <a href="#skills"> <GiSkills/> Skills</a>
        <a href="#education"> <PiGraduationCap/> Education</a>
        <a href="#portfolio"> <LuLayers/> Portfolio</a>
        <a href="#contact"> <BiMessage/> Contact</a>
      </div>
      <div className="footer3">
        <h4>FOLLOW ME</h4>
        <div className="footerIcons">
          <FaFacebookSquare className="footerIcon" />
          <BsInstagram className="footerIcon" />
          <BsTwitter className="footerIcon" />
          <FaLinkedin className="footerIcon" />
          <BiLogoGithub className="footerIcon" />
        </div>
      </div>
      <div className="footer4">
        <h4>CONTACT ME</h4>
        <p> <BsFillTelephoneOutboundFill/> +92 311 3318633</p>
        <p> <RiMailCheckFill/> hk7356231@gmail.com</p>
      </div>
    </footer>
  );
};

export default Footer;
